import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { MetaDataService } from "../../features/metaData/Uploader/metaData-uploader.service";
import { ToastrService } from 'ngx-toastr';
import { ConfirmModalComponent } from '../../_shared/confirm-modal/confirm-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-erase-metadata',
  templateUrl: './erase-metadata.component.html',
  styleUrl: './erase-metadata.component.scss'
})
export class EraseMetadataComponent {
   parserList: any[] = [];
  postType: string = '';
  postinfo: any = {};
  eraseinfo: any = {};

  selectControl = new FormControl('');
  selectUploader = new FormControl('SAMMS');
   constructor(
    public dialogRef: MatDialogRef<EraseMetadataComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private categoryService: MetaDataService,
    private toastrService: ToastrService,
		private MatDialog: MatDialog
    
  ) {}
 ngOnInit() {
    this.parserList = this.data.parserList;
    this.postType = this.data.postType;
    this.postinfo = this.data.postinfo || {};
    this.eraseinfo = this.data.eraseinfo || {};
  }



postData() {
  if (!this.selectControl.value) {
    this.toastrService.error('Please select parser');
    return;
  }

  const opType = this.postType === 'post' ? 'Post' : 'Erase';

  const initialState = {
    title: `${opType} Data`,
    message: `Are you sure you want to ${opType.toLowerCase()} this data on ${this.selectUploader.value}?`
  };

  const confirmRef = this.MatDialog.open(
    ConfirmModalComponent,
    { disableClose: true, data: initialState }
  );

  confirmRef.afterClosed().subscribe((confirmed: boolean) => {
    if (!confirmed) return;

    const waitToast = this.toastrService.info(
      'Please wait...',
      'Processing',
      { disableTimeOut: true }
    );

    try {
      if (this.postType === 'post') {
        this.postinfo.path = this.selectControl.value;
        this.postinfo.uploadType = this.selectUploader.value;
        this.toastrService.clear(waitToast.toastId);
        this.dialogRef.close({
          status: 'created',
          data: this.postinfo
        });

      } else {
        this.eraseinfo.path = this.selectControl.value;

        this.toastrService.clear(waitToast.toastId);
        this.toastrService.success('Data erased successfully');

        this.dialogRef.close({
          status: 'deleted',
          data: this.eraseinfo
        });
      }
    } catch (error) {
      this.toastrService.clear(waitToast.toastId);
      this.toastrService.error('Something went wrong');
    }
  });
}

}
